export type StatusReason = PrintingStatusReason | BusyStatusReason;

export enum PrintingStatusReason {
    NO_REASON = 0,
    PREPARING_FOR_PRINT = 1,
    HEATING = 2,
    PAUSED = 3,
    PAUSED_NO_MATERIAL = 4,
    COMPLETED = 5,
    STOPPED = 6,
    HOMING = 7,
    PARSING = 8
}

export enum BusyStatusReason {
    NO_REASON = 0,
    INITIALIZING = 1,
    WAITING_FOR_MATERIAL_SETUP = 2,
    WAITING_FOR_USER_ACTION = 3
}
